import React from "react"
import { Link, graphql } from "gatsby"
import TwoCol from "gatsby-theme-wirehead-bulma/src/twocol"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import { MDXRenderer } from "gatsby-plugin-mdx"
import wrappedImageList from "../components/wrappedimagelist"

export default function PageTemplate({ data, location, pageContext }) {
  const { mdx, allSitePage } = data // data.markdownRemark holds your post data
  const { body } = mdx

  const imgs = wrappedImageList(mdx.srcImages);
  var pages = data.allSitePage.edges.map(article => {
    return (
      <li>
        <Link
          to={article.node.path}
          key={article.node.path}
          className="navbar-item"
        >
          {article.node.context.title}
        </Link>
      </li>
    )
  })
  return (
    <Layout posted={pageContext.date} updated={pageContext.updated}>
      <SEO
        title={pageContext.title}
        description={pageContext.excerpt} />
    <section className="section">
    <TwoCol
      left={
          <div className="content">
            <h1 className="title">{pageContext.title}</h1>
            <MDXRenderer imgs={imgs} pages={allSitePage}>{body}</MDXRenderer>
          </div>
        }
      right={
        <ul className="menu-list">
        {pages}
        </ul>
      }
      />
    </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($id: String, $path: String) {
    mdx(id: { eq: $id }) {
      body
      id
      fields {
        sidebar
      }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        type
        description
        sidebar
      }
      srcImages {
        id
        key
        maxSize
        size
        srcSet
        srcPath
        width
        height
        sqSrcSet
        srcSet
      }
      excerpt(pruneLength: 300)
    }
    allSitePage(filter: { context: { parent: { eq: $path } } }) {
      edges {
        node {
          context {
            id
            depth
            parent
            title
          }
          path
        }
      }
    }
  }
`
